/**
 * Wrapper component to handle a single form checkbox input field
 * that use Formik and Reactstrap.
 */
import { useField } from "formik";
import { FormFeedback, FormGroup, Input, Label } from "reactstrap";

/**
 * Formik Checkbox field.
 */
const SingleCheckboxInput = ({ label, ...other }) => {
  const [field, meta] = useField(other);
  const invalid = Boolean(meta.touched && meta.error);
  return (
    <FormGroup check className="mb-3">
      <Input
        {...field}
        {...other}
        type="checkbox"
        invalid={invalid}
        checked={typeof field.value === "undefined" ? false : field.value}
        value={typeof field.value === "undefined" ? "" : field.value}
      />{" "}
      {label && (
        <Label check for={other.id}>
          {label}
        </Label>
      )}
      {invalid ? <FormFeedback>{meta.error}</FormFeedback> : null}
    </FormGroup>
  );
};

export default SingleCheckboxInput;
